import { useEffect } from 'react';
import env from 'src/env';

const LogOut = () => {
    useEffect(() => {
        const ssoVersion = localStorage.getItem('ssoVersion');
        const ssoUrl = ssoVersion === '2' ? env.ssoV2Url : env.ssoV1Url;
        localStorage.clear();

        window.location.href = `${ssoUrl}/logout`;
    }, []);

    return <></>;
};

export default LogOut;